import React from "react";
import { Box, Container } from "@material-ui/core";
import { Covid19VaccineCertificate } from "../../components";

const AppointmentVaxCertificate = () => {
  return (
    <Box pt={2}>
      <Container maxWidth="xs" data-cy="vax-certificate-view">
        <Covid19VaccineCertificate />
      </Container>
    </Box>
  );
};

export { AppointmentVaxCertificate };
